import * as tslib_1 from "tslib";
import { OnInit } from "@angular/core";
import { Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { Agent } from "src/app/shared/models/agent.model";
import { Helper } from "src/app/shared/helpers/helper";
import { ServiceRequest } from "src/app/shared/models/service-request.model";
import { Alert } from "src/app/shared/class/Alert";
import * as _ from "lodash";
export class ServiceRequestAddAgentComponent {
    constructor(authService, spinner, route, serviceRequestService, fb, router) {
        this.authService = authService;
        this.spinner = spinner;
        this.route = route;
        this.serviceRequestService = serviceRequestService;
        this.fb = fb;
        this.router = router;
        this.goback = "../list";
        this.queryParams = {};
        this.subscription = new Subscription();
        this.serviceRequests = [];
        this.agents = [];
    }
    ngOnInit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.route.queryParams.subscribe((params) => (this.queryParams = params));
            this.associateAgentForm = this.fb.group({
                scheduleId: this.fb.control(null, Validators.required),
                agentId: this.fb.control(null, Validators.required),
            });
            this.spinner.show();
            yield this.loadServiceRequests();
            yield this.loadAgents();
            this.spinner.hide();
        });
    }
    loadAgents() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getAgents();
                this.agents =
                    data.status === undefined ? Agent.orderAgentByName(data) : [];
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    onSubmit() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.associateAgentForm.valid) {
                this.spinner.show();
                this.subscription.add(this.serviceRequestService
                    .updateServiceRequestAgent(this.associateAgentForm.get("agentId").value, this.associateAgentForm.get("scheduleId").value)
                    .subscribe(() => {
                    this.spinner.hide();
                    Alert.success(Alert.getMessage().success.save);
                }, (error) => {
                    if (error.status === 200 || error.status === 201) {
                        this.spinner.hide();
                        Alert.success(Alert.getMessage().success.save).then(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                            this.spinner.show("mailSpinner");
                            const emailSended = yield this.serviceRequestService.sendAgentEmail(this.associateAgentForm.get("agentId").value, this.associateAgentForm.get("scheduleId").value);
                            if (!_.isEmpty(emailSended.error)) {
                                this.spinner.hide("mailSpinner");
                                Alert.warning(Alert.getMessage().errors.sendEmail).then(() => {
                                    this.router.navigate(["../serviceRequest/list"]);
                                });
                            }
                            else {
                                this.spinner.hide("mailSpinner");
                                Alert.success(Alert.getMessage().success.sendEmail).then(() => {
                                    this.router.navigate(["../serviceRequest/list"]);
                                });
                            }
                        }));
                    }
                    else {
                        this.spinner.hide();
                        Helper.handleError(error);
                    }
                }));
            }
        });
    }
    loadServiceRequests() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const data = yield this.serviceRequestService.getSchedules("agent=null");
                this.serviceRequests = data.status === undefined ? data : [];
                this.serviceRequests = ServiceRequest.orderByDate(this.serviceRequests, "desc");
            }
            catch (error) {
                console.error(error);
            }
        });
    }
}
